<div class="rtl relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-white border-0">
    <div class="rounded-t border-b-2 mb-0 p-6">
      <div class="flex justify-between">
        <h5 class="text-primary text-lg font-bold "> {{'General.Messages'|translate}} </h5>
        <h6> <button class="bg-primary text-white rounded pb-2 pt-1 px-3 text-base" 
            (click)="modal.open()"> + پیام جدید </button> </h6>
  
      </div>
        
    </div>

    <div class="flex flex-wrap pt-6">
      <div class="w-full lg:w-3/12 px-4">
        <div class="relative w-full mb-3">
          <label class="block text-blueGray-600 text-sm font-bold mb-2"> جستجو </label>
          <input type="text" [(ngModel)]="searchInp.title" (keyup)="getMessagesList(0)"
            class="p-3 placeholder-blueGray-300 text-blueGray-600 border-gray-300 rounded text-sm w-full">
        </div>
      </div>
    </div>

    <div class="flex-auto p-4">
        <div class="relative w-full overflow-x-auto rounded-md">
            <table class="w-full bg-transparent border-collapse">
              <thead class="bg-primary text-white">
                <tr>
                  <th class="align-middle border border-solid p-3 text-base border-l-0 border-r-0 font-semibold" >
                    متن پیام
                  </th>
                  <th class="align-middle border border-solid p-3 text-base border-l-0 border-r-0 font-semibold" >
                    نوع پیام
                  </th>
                  <th class="align-middle border border-solid p-3 text-base border-l-0 border-r-0 font-semibold" >
                    گیرنده
                  </th>
                  <th class="align-middle border border-solid p-3 text-base border-l-0 border-r-0 font-semibold" >
                    تاریخ
                  </th>
                  <th class="align-middle border border-solid p-3 text-base border-l-0 border-r-0 font-semibold" >
                    حذف
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let msg of messageList" class="border-b">
                  <td class="border-t-0 align-middle border-l-0 border-r-0 text-sm p-3">
                      {{msg.text}}
                  </td>
                  <td class="border-t-0 align-middle border-l-0 border-r-0 text-sm p-3">
                      {{msg.messageType==0?'گروهی':msg.messageType==1?'خصوصی':null}}
                  </td>
                  <td class="border-t-0 align-middle border-l-0 border-r-0 text-sm p-3">
                    {{msg.type==0?'کاربر':msg.type==1?'پزشک':null}} 
                    <span *ngIf="msg.messageType==1"> - {{msg.userName}}   </span>
                  </td>
                  <td class="border-t-0 align-middle border-l-0 border-r-0 text-sm p-3">
                    {{(msg.createAt|shamsiDate)}}
                  </td>
                  <td class="border-t-0 align-middle border-l-0 border-r-0 text-sm p-3">
                    <button class="bg-red-500 text-white rounded p-2 text-sm" type="button" (click)="msgId=msg.id;del.open()">
                      <img src="../../../../../assets/img/icon/trash.svg" alt=""> </button>
                  </td>
                </tr>
                
              </tbody>
            </table>
          </div>
          <div class="card flex justify-center">      
            <p-paginator
            dir="rtl"
            (onPageChange)="getMessagesList($event.page)"
            [first]="first"
            [rows]="rows"
            [totalRecords]="collectionSize"
            [showCurrentPageReport]="true"
            [showPageLinks]="false"
            [showJumpToPageDropdown]="false"
            currentPageReportTemplate="نمایش {first} تا {last} از {totalRecords} رکورد" />
          </div>
    </div>
</div>
    
<p-toast dir="rtl"></p-toast>




<!-- MODAL SECTION -->

<app-modal #modal>
  <!--header-->
  <div class="flex items-start justify-between p-2 border-b border-solid border-blueGray-200 rounded-t">
    <h3 class="text-lg font-semibold">
        ارسال پیام جدید
    </h3>
    <button class="p-1 bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none" (click)="modal.close()">
      <span class="bg-transparent text-black opacity-5 h-6 w-6 text-2xl block outline-none focus:outline-none">
        ×
      </span>
    </button>
  </div>
  <!--body-->

  <div class="relative py-2 flex-auto">
    <div class="flex flex-wrap text-start">

      <div class="w-full lg:w-6/12 p-2">
          <div class="relative w-full mb-3">
              <label class="block text-blueGray-600 text-xs font-bold mb-2">
                  نوع پیام
              </label>
              <select [(ngModel)]="messageType" name="type" (ngModelChange)="getUsers()"
                  class="px-3 py-3 placeholder-blueGray-300 text-blueGray-600 rounded text-sm border-gray-300 w-full" >
                <option value="public-user"> گروهی کاربران </option>
                <option value="public-doctor"> گروهی پزشکان </option>
                <option value="private-user"> خصوصی کاربر </option>
                <option value="private-doctor"> خصوصی پزشک </option>
              </select>
          </div>
      </div>
      <div class="w-full lg:w-6/12 p-2">
          <div class="relative w-full mb-3">
              <label class="block text-blueGray-600 text-xs font-bold mb-2">
                  جستجو 
              </label>
              <p-autoComplete 
                class="placeholder-blueGray-300 text-blueGray-600 rounded text-sm border-gray-300 w-full"
                [(ngModel)]="selectedItem"
                [suggestions]="userSuggestion"
                (completeMethod)="search($event)"
                (onSelect)="onItemSelected($event)"
                [field]="'fullName'">  <!-- Use the computed property -->

                <!-- Custom template for displaying both fields in the dropdown -->
                <ng-template let-item pTemplate="item">
                  <div>{{ item.firstName }} {{ item.lastName }}</div>
                </ng-template>

              </p-autoComplete>

          </div>
      </div>
      <div class="w-full p-2">
          <div class="relative w-full mb-3">
              <label class="block text-blueGray-600 text-xs font-bold mb-2">
                  متن پیام 
              </label>
              <textarea cols="30" rows="10" name="text" [(ngModel)]="messageModel.text"
                  class="border-gray-300 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 rounded text-sm w-full" ></textarea>
          </div>
      </div>
  </div>
  </div>
  <!--footer-->
  <div class="flex items-center justify-between p-2 border-solid border-blueGray-200 rounded-b">
    <button class="text-red-500 border-red-500 background-transparent font-bold px-6 py-2 rounded text-sm my-2 ease-linear transition-all duration-150" type="button" (click)="modal.close()">
      انصراف
    </button>
    <button (click)="sendNewMessage()" class="bg-primary text-white active:bg-red-500 font-bold text-sm px-6 py-2 rounded shadow hover:shadow-lg my-2 ease-linear transition-all duration-150" type="button">
      ارسال
    </button>
  </div>
</app-modal>


<app-modal #del>
  <!--header-->
  <div class="flex items-start justify-between p-2 border-b border-solid border-blueGray-200 rounded-t">
    <h3 class="text-2xl font-semibold">
      حذف پیام 
    </h3>
    <button
      class="p-1 bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
      (click)="del.close()">
      <span class="bg-transparent text-black opacity-5 h-6 w-6 text-2xl block outline-none focus:outline-none">
        ×
      </span>
    </button>
  </div>
  <!--body-->
  <div class="relative flex-auto">
    <p class="mt-4 mb-12 text-blueGray-500 text-base text-start leading-relaxed">
      آیا از حذف این پیام اطمینان دارید؟
    </p>
  </div>
  <!--footer-->
  <div class="flex items-center justify-between py-2 border-solid border-blueGray-200 rounded-b">
    <button
      class="text-red-500 border-red-500 background-transparent font-bold px-6 py-2 rounded text-sm my-2 ease-linear transition-all duration-150"
      type="button" (click)="del.close()">
      انصراف
    </button>
    <button
      class="bg-red-500 text-white active:bg-red-500 font-bold text-sm px-6 py-2 rounded shadow hover:shadow-lg my-2 ease-linear transition-all duration-150"
      type="button" (click)="deleteMessage()">
      حذف
    </button>
  </div>
</app-modal>